import styled from "styled-components";

import { ReactComponent as EditorLogoMarkIcon } from "assets/images/editor-logo-mark.svg";
import logo from "assets/images/logo.svg";
import { editorTopNavChrome } from "core/editor/constants/editorTopNavChrome";

const StyledLogo = styled.img`
  cursor: pointer;
`;

const LogoMark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${editorTopNavChrome.logoMarkSizePx}px;
  height: ${editorTopNavChrome.logoMarkSizePx}px;
  border-radius: ${editorTopNavChrome.logoMarkRadiusPx}px;
  background-color: ${editorTopNavChrome.logoMarkBackground};
  cursor: pointer;
  overflow: hidden;

  svg {
    width: ${editorTopNavChrome.logoIconSizePx}px;
    height: ${editorTopNavChrome.logoIconSizePx}px;
    display: block;
    flex-shrink: 0;
  }
`;

export const Logo = () => {
  return <StyledLogo src={logo} alt="Superblocks" data-test="brand-logo" />;
};

export const EditorLogo = () => {
  return (
    <LogoMark aria-label="Superblocks home">
      <EditorLogoMarkIcon data-test="brand-logo" />
    </LogoMark>
  );
};
